import { CoreData, Player } from "../types/CoreData";
import { AuthData } from "../types/AuthData";

export const coreDataStore = {
  auth_data: null as AuthData | null,
  core_data: null as CoreData | null,
};

export const getClientPlayer = (uuid: string): Player | null => {
  if (coreDataStore.core_data) {
    coreDataStore.core_data.players.map((player) => {
      if (player.uuid == uuid) {
        return player;
      }
    });
  }
  return null;
};
